import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export const COMMUNICATION_TYPE_AUTO_EMAIL = 'autoEmail';
export const COMMUNICATION_TYPE_MANUAL_EMAIL = 'manualEmail';
export const COMMUNICATION_TYPE_AUTO_SMS = 'autoSms';
export const COMMUNICATION_TYPE_MANUAL_SMS = 'manualSms';
export const COMMUNICATION_TYPE_MANUAL_LETTER = 'manualLetter';
export const COMMUNICATION_TYPE_MANUAL_CALL = 'manualCall';
export const COMMUNICATION_TYPE_MANUAL_OTHER = 'manualOther';
export const COMMUNICATION_TYPE_MANUAL_DATOVKA = 'manualDatovka';
export const COMMUNICATION_TYPE_BLOCK_ORGANISATION = 'blockOrganisation';


export const CommunicationTypes = {
	[COMMUNICATION_TYPE_AUTO_EMAIL]: {
		name: "Automatický e-mail",
		description: "Automaticky generovaný e-mail",
		forUser: false,
		forAction: true
	},
	[COMMUNICATION_TYPE_MANUAL_EMAIL]: {
		name: "Manuální e-mail",
		description: "Ruční e-mail",
		forUser: true,
		forAction: false
	},
	[COMMUNICATION_TYPE_AUTO_SMS]: {
		name: "Automatická SMS",
		description: "Automaticky generovaná SMS",
		forUser: false,
		forAction: true
	},
	[COMMUNICATION_TYPE_MANUAL_SMS]: {
		name: "Manuální SMS",
		description: "Ručně napsaná SMS",
		forUser: true,
		forAction: false
	},
	[COMMUNICATION_TYPE_MANUAL_LETTER]: {
		name: "Dopis",
		forUser: true,
		forAction: false
	},
	[COMMUNICATION_TYPE_MANUAL_CALL]: {
		name: "Telefonát",
		description: "Ručně provedený telefonát",
		forUser: true,
		forAction: false
	},
	[COMMUNICATION_TYPE_MANUAL_OTHER]: {
		name: "Jiné",
		description: "Jiný typ komunikace",
		forUser: true,
		forAction: true
	},
	[COMMUNICATION_TYPE_MANUAL_DATOVKA]: {
		name: "Datová schránka",
		description: "Komunikace přes datovou schránku",
		forUser: true,
		forAction: false
	}
    ,
    [COMMUNICATION_TYPE_BLOCK_ORGANISATION]: {
        name: "Blokace organizace",
        description: "Pravidlo pro zablokování organizace",
        forUser: false,
        forAction: true
    }
};


export default declareEntity({
	name: "OrganisationOverdueBillCommunication",
	entity: "organisationOverdueBillCommunications",
	graphQL: "OrganisationOverdueBillCommunication",
	dynamoPrefix: 'org',
	storageType: 'central',
	defaultTitle: (data) => data['message'] || "",
	fields: (types) => ({
		id: {
			type: "id",
			defaultValue: () => uuidv4(),
			primaryKey: true,
			required: true,
			userEditable: false,
		},
		timestamp: {
			type: "datetime",
			required: true,
			userEditable: false,
			description: "Timestamp of the communication"
		},
		message: {
			type: "string",
			required: true,
			userEditable: true,
			description: "Message content"
		},
		htmlMessage: {
			type: "html",
			required: false,
			userEditable: true,
			description: "HTML formatted message content"
		},
		recipient: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Recipient of the message"
		},
		type: {
			type: "enum",
			values: CommunicationTypes,
			required: false,
			userEditable: true,
			description: "Type of communication (e.g. 'email', 'notification', 'sms')"
		},
		dateTime: {
			type: "datetime",
			required: true,
			userEditable: false,
		},
		createdAt: {
			type: "datetime",
			defaultValue: () => new Date(),
			userEditable: false,
		},
	}),
});


